import React, { Component } from 'react';

class TemplateBanner extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
          <div class="banner">
            <div class="banner-small"></div>
            <div class="spacer"></div>
            <nav class="banner-large navbar navbar-expand-md navbar-light">
              <div class="container">
                <div class="navbar-brand display-4" href="#"><h4 class="logo">The Arrhenius Project</h4></div>
                <button class="navbar-toggler btn btn-link format-clear" type="button" data-toggle="collapse" data-target="#banner-views" aria-controls="banner-views" aria-expanded="false" aria-label="Toggle navigation">
                  <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="banner-views">
                  <ul class="navbar-nav ml-auto">
                    <li class="view banner-button nav-item">
                      <a class="nav-link" href="#">Change View</a>
                    </li>
                    <li class="resources banner-button nav-item">
                      <a class="nav-link" href="#">Resources</a>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        );
    }
}

export default TemplateBanner;



// WEBPACK FOOTER //
// ./src/TemplateBanner.js